var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVahakMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5a9 9 0 100-18 9 9 0 000 18z",
    fill: "#223D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5c4.963 0 9 4.037 9 9s-4.037 9-9 9V.5z",
    fill: "#223D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.77 13.975H5.23a.704.704 0 01-.684-.533L3.038 7.408a.704.704 0 01.998-.8l2.433 1.216 1.927-3.211a.704.704 0 011.208 0l1.927 3.211 2.433-1.216a.704.704 0 01.998.8l-1.508 6.034a.704.704 0 01-.683.533z",
    fill: "#FFD71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.77 13.975c.324 0 .606-.22.684-.533l1.508-6.034a.704.704 0 00-.998-.8l-2.433 1.216-1.927-3.211A.704.704 0 009 4.27v9.704h3.77z",
    fill: "#D4AF37"
  })));
}

export default SvgVahakMember;